import { AllProjectCostAggregationsResponse, CostAggregationsQuery, CreateOrganizationDto, CreateOrganizationResponse, InviteOrganizationMemberDto, OrganizationCostAggregationsResponse, UpdateOrganizationBillingPlanDto, UpdateOrganizationMemberDto, FindOneOrganizationResponse, UpdateOrganizationDto, GetOrganizationMembersResponse } from '@/@types/Organization';
import { TheoryApiAxiosBase } from '@/repository/base/axiosBase';
import { OrganizationUpdateMode } from '@/@types/constant'

export class OrganizationsRepository {
  private requestBasePath = 'v1/organizations'
  private readonly axios = new TheoryApiAxiosBase();

  async createOrganization(createOrganizationDto: CreateOrganizationDto) {
    try {
      const responce = await this.axios.post<CreateOrganizationResponse>(this.requestBasePath, createOrganizationDto);
      return responce.data.results;
    } catch {
      // TODO: エラーハンドリング
    }
  }

  async fetchOrganizationCostAggregations(organizationId: number, query?: CostAggregationsQuery ) {
    try {
      const path = `${this.requestBasePath}/${organizationId}/cost-aggregations`
      const response = await this.axios.get<OrganizationCostAggregationsResponse>(path, { params: query });
      return response.data.results;
    } catch {
      // TODO: エラーハンドリング
    }
  }

  async fetchAllProjectCostAggregations(organizationId: number, query?: CostAggregationsQuery) {
    try {
      const path = `${this.requestBasePath}/${organizationId}/all-project-cost-aggregations`
      const response = await this.axios.get<AllProjectCostAggregationsResponse>(path, { params: query });
      return response.data.results;
    } catch {
      // TODO: エラーハンドリング
    }
  }

  async inviteOrganizationMember(inviteOrganizationMemberDto: InviteOrganizationMemberDto) {
    try {
      const path = `${this.requestBasePath}/invite-member`
      await this.axios.post<void>(path, inviteOrganizationMemberDto);
    } catch {
      // TODO: エラーハンドリング
    }
  }

  async updateOrganizationMember({ organizationMemberId, ...dto }: UpdateOrganizationMemberDto) {
    try {
      const path = `${this.requestBasePath}/members/${organizationMemberId}`
      await this.axios.patch<void>(path, dto);
    } catch {
      // TODO: エラーハンドリング
    }
  }

  async updateOrganizationBillingPlan(organizationId: number, updateOrganizationBillingPlanDto: UpdateOrganizationBillingPlanDto) {
    try {
      const path = `${this.requestBasePath}/${organizationId}/billing-plan`;
      await this.axios.patch<void>(path, updateOrganizationBillingPlanDto);
    } catch {
      // TODO: エラーハンドリング
    }
  }

  async getOrganizationMembers(organizationId: number, findKeyword: string) {
    try {
      if (!findKeyword) {
        findKeyword = '';
      }
      const path = `${this.requestBasePath}/${organizationId}/members?find-keyword=${findKeyword}`;
      const response = await this.axios.get<GetOrganizationMembersResponse>(path);
      return response.data.results;
    } catch {
      // TODO: エラーハンドリング
    }
  }

  async findOneOrganization(organizationId: number) {
    try {
      const path = `${this.requestBasePath}/${organizationId}`
      const response = await this.axios.get<FindOneOrganizationResponse>(path);
      return response.data.results;
    } catch {
      // TODO: エラーハンドリング
    }
  }

  async updateOrganization(organizationId: number, updateOrganizationDto: UpdateOrganizationDto) {
    try {
      const path = `${this.requestBasePath}/${organizationId}`;
      await this.axios.patch(path, updateOrganizationDto, { params: { 'update-mode': OrganizationUpdateMode.part }});
    } catch {
      // TODO: エラーハンドリング
    }
  }

}
